import React, { useState } from "react";
import { uploadProductSpecsCSV } from "../../../services/apiService";

const CsvUpload = ({ reloadData }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [dragOver, setDragOver] = useState(false);

  const handleFileChange = (file) => {
    setSelectedFile(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    if (e.dataTransfer.files.length > 0) {
      handleFileChange(e.dataTransfer.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      setUploading(true);
      await uploadProductSpecsCSV(formData);
      alert("File uploaded successfully");
      setSelectedFile(null);
      reloadData && reloadData();
    } catch (err) {
      alert("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ width: "100%", marginBottom: "20px" }}>
      {/* Button */}
      <div
  style={{
    display: "flex",
    justifyContent: "center",
    marginBottom: "12px",
  }}
>
  <label
    htmlFor="csvFile"
    style={{
      display: "inline-block",
      backgroundColor: "#facc15",
      color: "#000",
      padding: "8px 16px",
      borderRadius: "6px",
      fontWeight: 600,
      marginTop:"20px",
      cursor: "pointer",
    }}
  >
    Add CSV or EXCEL File
  </label>
</div>

      <input
        id="csvFile"
        type="file"
        accept=".csv,.xlsx,.xls"
        hidden
        onChange={(e) => handleFileChange(e.target.files[0])}
      />

      {/* Drop Area */}
      <div
        onDragOver={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
        style={{
          border: `2px dashed ${dragOver ? "#22c55e" : "#16a34a"}`,
          borderRadius: "8px",
          padding: "40px",
          textAlign: "center",
          color: "#64748b",
          fontSize: "15px",
          marginTop: "10px",
          background: dragOver ? "#f0fdf4" : "#fff",
        }}
      >
        DRAG AND DROP A FILE HERE
        {selectedFile && (
          <div style={{ marginTop: "10px", color: "#111827" }}>
            📄 {selectedFile.name}
          </div>
        )}
      </div>

      {/* Upload Button */}
      <div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: "15px",
  }}
>
  <button
    onClick={handleUpload}
    disabled={!selectedFile || uploading}
    style={{
      backgroundColor: uploading ? "#9ca3af" : "#16a34a",
      color: "#fff",
      border: "none",
      padding: "8px 18px",
      borderRadius: "6px",
      cursor: uploading ? "not-allowed" : "pointer",
      fontWeight: 600,
      textAlign: "center",
    }}
  >
    {uploading ? "Uploading..." : "Upload File"}
  </button>
</div>

    </div>
  );
};

export default CsvUpload;
